<template>
  <div>
    <swiper :options="swiperOption" class="swiper-box">
      <swiper-slide class="swiper-item">
          <img :src="listimages[0].replace('.resized.{bucket}', '')"  class="card-img-top audio-funny-img-pack"/>
            <audio controls class="audio-controls-funny-pack">
              <source :src="listaudio[0]">
            </audio>
      </swiper-slide>
      <swiper-slide class="swiper-item"><img :src="listimages[1].replace('.resized.{bucket}', '')"  class="card-img-top audio-funny-img-pack"/></swiper-slide>
      <div class="swiper-pagination"  style="bottom: 50px"  slot="pagination"></div>
      <div class="swiper-button-prev" slot="button-prev"></div>
      <div class="swiper-button-next" slot="button-next"></div>
    </swiper>
  </div>
</template>

<style lang="scss">
  .swiper-container {
    width: 320px;
    height: 320px;
    padding: 40px;
  }
  .swiper-slide {
    background-position: 50%;
    background-size: cover;
    width: 100%;
  }
  .audio-funny-img-pack {
    object-fit: cover;
    height: 240px;
    width: 240px;
    margin: 0 40px 0 0;
    display: flex;
    align-items: center;
  }
  .audio-controls-funny-pack {
    float: left;
    z-index: 1;
    width: 240px;
    margin: 0;
  }
</style>

<script>
export default {
  name: 'mix-offer',
  props: ['listaudio', 'listimages'],
  data () {
    return {
      swiperOption: {
        effect: 'flip',
        grabCursor: true,
        mousewheel: true,
        pagination: {
          el: '.swiper-pagination'
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/previews/MixOffer.vue